module.exports = __webpack_public_path__ + "img/gp-with-patient.93bf7d01.jpg";